import { css } from '@emotion/css'
import { colors } from 'settings/colors'

export const SharedSettings = {
  DEFAULT_MODAL_DRAWER_Z_INDEX: 200,
  DEFAULT_MODAL_Z_INDEX: 300,
  DEFAULT_ABOVE_ALL_MODAL_OVERLAY_Z_INDEX: 400,
  DEFAULT_MINI_STATS_BAR_Z_INDEX: 500,
  DEADULT_NOTIFICATION_Z_INDEX: 600,
  DEFAULT_CAMERA_Z_INDEX: 1000, //defined in @ionic/pwa-elements, https://capacitorjs.com/docs/web/pwa-elements
  FIRST_DAY_OF_DATA_FOR_MANY_THINGS: '2016-01-01',
  HELP_CENTER_URL: 'https://hub-support.semios.com/en/collections/4030060-semios-hub',
  SEMIOS_API_DOCS_URL: 'https://developers.semios.com/v1/',
  SSC_INSTALLATION_GUIDES_URL:
    'https://hub-support.semios.com/en/collections/10655307-assembly-install-guides',
  S3_PUBLIC_BUCKET_URL: 'https://customer-apps-general-public-bucket.s3.us-west-2.amazonaws.com',
  LOCAL_STORAGE_KEYS: {
    AUTH_TOKEN: 'token',
  },
  /**
   * Flat parts of the app-wide Select chevron styling; the chevron's shape, colour and rotation
   * live in settings/mantine-overrides.css
   */
  MANTINE_SELECT_RIGHT_ICON_CHANGER: {
    input: { cursor: 'pointer', paddingRight: 27 },
    section: {
      marginRight: -3,
    },
  },
  MANTINE_SELECT_UNDERLINE_SEPARATOR_STYLES: {
    options: {
      padding: '0px 12px',
    },
    groupLabel: {
      padding: '4px 0',
      borderBottom: `1px solid ${colors.grey200}`,
    },
  },
  MANTINE_SELECT_UNDERLINE_SEPARATOR_CLASSNAMES: {
    groupLabel: css({ '&::after': { display: 'none' } }),
  },
  MANTINE_TABS_UNDERLINE_CLASSNAMES: {
    list: css({
      button: {
        'fontSize': 15,
        'padding': 10,
        'color': colors.primary,
        '&:hover': { background: 'transparent', fontWeight: 600 },
        '&[data-active]': {
          'fontWeight': 700,
          'color': colors.midnight,
          'borderBottom': `4px solid ${colors.midnight}`,
          '&:hover': { fontWeight: 700, borderColor: colors.midnight },
        },
        '&:not(:first-of-type)': { marginLeft: 20 },
      },
    }),
  },
  DEFAULT_FORECAST_DAYS: 14,
  MINIMUM_WIDTH_WIDE_SCREEN: 1113,
  MINIMUM_VIEWPORT_HEIGHT_FOR_DATE_RANGE_PICKER_DROPDOWN: 650,
  SPACING_FOR_THINGS_THAT_FLOAT_OVER_LEFT_SIDE_OF_MAP: {
    SPACING_WHEN_MENU_COLLAPSED: 10,
    SPACING_WHEN_MENU_OPEN: 315,
  },
  // TODO: we should just do this trapimage URL building on the backend
  TRAP_IMAGE_PREFIX_URL: 'https://s3-us-west-2.amazonaws.com/semiostrapimages/',
  TRAP_IMAGE_FILE_SUFFIX: 'jpg', // note: no dot in this value
  INTERCOM_APP_ID: 'xsy9y46t', // TODO: Blair: Think about if we want this as an env var. Also think about hubspot, etc and their ids.
}
